import { PixelRatioImage, type PixelRatioImageProps } from "@/components/common/pixel-ratio-image";
import agentCreditsRecordEmptyImage from "@/assets/agent/agent-credits-record-empty.webp";

export const AgentCreditsImage = (props: Omit<PixelRatioImageProps, "images">) => {
  return (
    <PixelRatioImage
      images={[agentCreditsRecordEmptyImage]}
      {...props}
    />
  );
};

AgentCreditsImage.displayName = 'AgentCreditsImage';
